export default __webpack_public_path__ + "img/StokesPreston_Logo-01.jpg";